import React from 'react';
import PropTypes from 'prop-types';


function Error({ message }) {

    return (
        <div className="card-panel red darken-4 col s12 error">
            {message}
        </div>
    )
}

Error.propTypes = {
    message: PropTypes.string.isRequired
}
export default Error;